// Stub highlight slice
import { createSlice } from "@reduxjs/toolkit";

const highlightSlice = createSlice({
  name: "highlight",
  initialState: { highlight: false, uploadHighlight: false },
  reducers: {
    setHighlight: (state, action) => {
      state.highlight = action.payload;
    },
    setUploadHighlight: (state, action) => {
      state.uploadHighlight = action.payload;
    },
  },
});

export const { setHighlight, setUploadHighlight } = highlightSlice.actions;
export default highlightSlice.reducer;
